import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'
import createLogger from 'vuex/dist/logger'
import Vuex from 'vuex'
import Vue from 'vue'
import { env as ENV } from '@didi/public-sdk'

Vue.use(Vuex)

const state = {
  env: ENV.isPassenger ? 'passenger' : (ENV.isDriver ? 'driver' : 'web'),
  verifyData: {},
  userInfo: {},
  roleId: 999,
  trinity_collect_reason: null,
  orders: [],
  authState: null,
  nameInfo: {},
  hasRealName: false,
}

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: debug ? [createLogger()] : []
})
